exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-price-dialog{padding:.2rem .4rem .4rem}.card-price-dialog__tip{margin:0 0 .2rem;font-size:.34rem;color:#666}", ""]);

// exports
